import { useEffect, useState } from 'react';
import { IListOptionsSupport } from '../../types/OpsSupport';
import { AddNewCity, HeaderOpsSuportTab, InviteEmailToOrganization } from './Components';

import './OpsSupportModule.scss';

const OpsSupportModule = () => {
  const [selectSupportOption, setSelectSupportOption] = useState<IListOptionsSupport>();

  const listOfOptionsSuppport: IListOptionsSupport[] = [
    { id: 1, name: 'Agregar Nueva Ciudad', component: <AddNewCity /> },
    { id: 2, name: 'Invitar Email a Organizacion', component: <InviteEmailToOrganization /> }
  ];

  const defaultOption = () => {
    if (listOfOptionsSuppport && listOfOptionsSuppport.length > 0) {
      setSelectSupportOption(listOfOptionsSuppport[0]);
    }
  };

  const handleChangeSupportOption = (listOption: IListOptionsSupport) => {
    if (listOption) {
      setSelectSupportOption(listOption);
    }
  };

  useEffect(() => {
    defaultOption();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  return (
    <div id="opsSupportModule">
      <HeaderOpsSuportTab
        listOfOptionsSuppport={listOfOptionsSuppport}
        handleChangeSupportOption={handleChangeSupportOption}
        selectSupportOption={selectSupportOption}
      />
      <div className="bodySupport">{!!selectSupportOption && selectSupportOption.component}</div>
    </div>
  );
};

export default OpsSupportModule;
